import axios from 'axios'
// import jwt_decode from "jwt-decode"
// const API_URL = 'http://103.153.62.26:8085/api/investor/'

class AuthService {
    login(user) {
        const data = new FormData()
        data.append('username', user.username)
        data.append('password', user.password)
        return axios
        .post('investor/auth/login/', data)
        .then(response => {
            localStorage.setItem('remember', user.remember_me)
            localStorage.setItem('access_token', response.data.data.access_token)
            localStorage.setItem('refresh_token', response.data.data.refresh)

            const token = localStorage.getItem('access_token');
            if (token) {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            }
            // const token = localStorage.getItem('access_token')
            // const access_token = jwt_decode(token)
            // const access_exp = access_token.exp
            // const user_id = access_token.user_id

            // console.log("Logged In: ", response.data.data)
            // localStorage.setItem('access_exp', access_exp)
            // localStorage.setItem('user_id', user_id)
            // if(response.data.data.access_token){
            //     console.log(response.data)
            //     localStorage.setItem('user', JSON.stringify(response.data))
            // }

            return response.data
        })
        
    }

    logout() {
        localStorage.removeItem('access_token');
        localStorage.removeItem('user_id');
        localStorage.clear();
    }

    register(user) {
        return axios.post('registration/', {
            name: user.name,
            username: user.username,
            email: user.email,
            password: user.password
        })
    }
}

export default new AuthService();